<div class="code-container">
    <code>{{ code }}</code>
    <button
        size="xs"
        appearance="flat"
        iconStart="@tui.copy"
        tuiIconButton
        [tuiHint]="copyHintText"
        tuiHintDirection="right"
        type="button"
        (click)="copyCode()"
    ></button>
</div>
